import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

import { cn } from '../../lib';

interface IInformationWidgetProps {
  actions?: ReactNode;
  content?: ReactNode;
  className?: string;
  description?: TTextLocalized;
  icon?: LucideIcon;
  subtitle?: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * Information widget displaying grading information.
 */
export function InformationWidget({
  actions,
  className,
  content,
  description,
  icon: Icon,
  subtitle,
  title,
}: IInformationWidgetProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-4 md:gap-6 md:py-4 lg:max-w-md',
        className
      )}
    >
      <div
        className="
          bg-surface-100 shadow-loader-background/50 flex flex-col space-y-4 rounded border
          p-6 shadow-sm
        "
      >
        <div className="flex flex-col">
          <div className="space-y-6">
            {Icon ? (
              <Icon className="text-primary-700 dark:text-primary-400 size-12 stroke-1" />
            ) : null}

            <h5 className="text-foreground">
              <Text className="truncate" text={title} />
            </h5>

            <div className="text-foreground-light flex flex-col space-y-2">
              {subtitle ? (
                <p className="text-foreground-light text-sm">
                  <Text text={subtitle} />
                </p>
              ) : null}

              {description ? (
                <p className="text-text-caption flex w-full text-sm">
                  <Text text={description} />
                </p>
              ) : null}
            </div>

            {actions || null}
          </div>
        </div>

        {content || null}
      </div>
    </div>
  );
}
